export default {
    form: {
        serverError: 'Ups! there is something wrong with the website administration.',
        globalError: 'Please double-check the required fields and confirm again.',
        validateMessages: {
            default: 'Validation error on field {errorKey}.',
            required: 'Please enter your {errorKey}.',
            email: 'Please enter a valid email address.',
            password: 'The Password Must Be At Least 8 characters.',
            enum: '{errorKey} must be one of [{enum}].',
            whitespace: '{errorKey} cannot be empty.',
            phone: 'Please enter a valid {errorKey}.',
            date: {
                format: '{errorKey} is invalid for format date.',
                parse: '{errorKey} could not be parsed as date.',
                invalid: '{errorKey} is invalid date.',
            },
            string: {
                len: '{errorKey} must be exactly {len} characters.',
                min: '{errorKey} must be at least {min} characters.',
                max: '{errorKey} cannot be longer than ${max} characters.',
                range: '{errorKey} must be between {min} and {max} characters.',
            },
            number: {
                len: '{errorKey} must equal {len}.',
                min: '{errorKey} cannot be less than {min}.',
                max: '{errorKey} cannot be greater than {max}.',
                range: '{errorKey} must be between {min} and {max}.',
            },
            array: {
                len: '{errorKey} must be exactly {len} in length.',
                min: '{errorKey} cannot be less than {min} in length.',
                max: '{errorKey} cannot be greater than {max} in length.',
                range: '{errorKey} must be between {min} and {max} in length.',
            },
            pattern: {
                mismatch: '{errorKey} does not match pattern {pattern}.',
            },
        },
    },
};
//# sourceMappingURL=en.js.map